import React from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { projects } from "../../data/projects";
import ProjectEmbed from "../Projects/ProjectEmbed";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-start flex-lg-nowrap">
            <Col md={5} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                My portfolio
              </h1>

              <h1 className="heading-name">
                <strong className="main-name"> Mohammed Khan</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={7} className="hero-projects-col">
              <div className="hero-project-heading-block">
                <h2 className="hero-project-heading-title">
                  SaaS that I <strong className="purple">architected &amp; shipped</strong>
                </h2>
                <p className="hero-project-heading-sub">
                  Production apps that solve real business problems—multi-tenant
                  systems, auth, and integrations from design to deployment.
                </p>
              </div>
              <Carousel
                className="hero-project-carousel"
                fade
                indicators
                controls
                interval={6000}
                pause="hover"
              >
                {projects.map((project) => (
                  <Carousel.Item key={project.title}>
                    <div className="hero-project-embed-wrap">
                      <ProjectEmbed
                        src={project.link}
                        className="hero-project-embed"
                        openHref={project.link}
                        linkLabel={project.title}
                      />
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
